// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_2rzpvw","header":"header_16jMTv","text":"text__qNRbe"};